import "./task-details-mob.component.scoped.sass";
import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import moment from "moment";

export const TaskDetailsMobComponent = (props: any) => {
  const { loading, data } = props;
  const { name, minutes, icon, date } = data;
  const formattedDate = moment(date).format("ddd, DD.MM.YYYY a hh:mm");

  const formattedTime = (minutes: number): string => {
    const outputHours = Math.round(minutes / 60);
    const outputMinutes = minutes - (outputHours * 60);
    return `${outputHours}h ${outputMinutes}m`;
  }

  return (
    <div className="wrapper">
      {loading && (
        <div className="loader">
          <CircularProgress />
        </div>
      )}
      {!loading && (
        <div className="task-details">
          <div className="task-row">
            <div className="left-side">
              <div className="task-name">{ name }</div>
              <div className="task-date">{ formattedDate }</div>
            </div>
            <div className="right-side">
              <div className="task-icon">
                <img src={icon} alt="" />
              </div>
            </div>
          </div>
          <div className="line" />
          <div className="task-row">
            <div className="user-details">
              <div className="user-img">
                <img src="/profile.svg" alt="" />
              </div>
              <div className="user-name">
                Hermann <br /> Mustermann
              </div>
            </div>
            <div className="task-time">{formattedTime(minutes)}</div>
          </div>
        </div>
      )}
    </div>
  );
};
